import classNames from 'clsx';
import React from 'react';
import type { TableInstance } from 'react-table';

import { TABLE_ROW_SIZE_MOBILE } from '../../../constants';
import type { Tournament } from '../../../types/MTT';
import TableBody from '../TableBody/TableBody';

import styles from './Table.scss';

interface MobileTableProps {
  className?: string;
  tableProps: TableInstance<Tournament>;
  selectedRowId?: number;
  loading: boolean;
  handleRowClick(rowId: number): void;
  showEmptyImage?: boolean;
}

const Table: React.FC<MobileTableProps> = ({
  tableProps: { rows, getTableProps, getTableBodyProps, prepareRow },
  handleRowClick,
  loading,
  selectedRowId,
  className,
  showEmptyImage
}) => (
  <div
    data-testid="tournaments-table-mobile"
    {...getTableProps()}
    className={classNames(styles.table, className)}
  >
    <TableBody
      height=""
      width="100%"
      bodyProps={getTableBodyProps()}
      itemData={{
        rows,
        selectedRowId,
        prepareRow,
        onRowClick: handleRowClick,
        classes: { row: styles.tableRow, cell: styles.cell }
      }}
      itemSize={TABLE_ROW_SIZE_MOBILE}
      itemCount={rows.length}
      loading={loading}
      showEmptyImage={showEmptyImage}
      autoSizer
    />
  </div>
);

export default Table;
